import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clickAsLink } from 'helpers/link_helpers';

import FilterButton from 'components/search_sidebar/filter_button';
import TagsFilter from 'bundles/tags/tags_filter';

import { clearFiltersIfEmpty, selectExcludeTags, setTags } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

export class ResearchTagsFilter extends React.Component {
  static propTypes = {
    aggregateView: PropTypes.bool,
    availableTags: PropTypes.array.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func,
    editDatabasePath: PropTypes.string,
    excludeTags: PropTypes.bool.isRequired,
    selectedTags: PropTypes.array.isRequired,
    selectExcludeTags: PropTypes.func.isRequired,
    setTags: PropTypes.func.isRequired,
  };

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleTagChange = (tags) => {
    const { setTags } = this.props;
    setTags(tags);
    this.handleRetrieveRecords();
  };

  handleAddTag = (tag) => {
    const { selectedTags } = this.props;
    selectedTags.push(tag);
    this.handleTagChange(selectedTags);
  };

  handleRemoveTag = (tag) => {
    const { selectedTags } = this.props;
    const newTags = selectedTags.filter(t => t !== tag);
    this.handleTagChange(newTags);
  };

  handleExcludeTagsChange = () => {
    const { selectExcludeTags } = this.props;
    selectExcludeTags();
    this.handleRetrieveRecords();
  }

  handleSelectAllChange = () => {
    const { setTags } = this.props;
    setTags([]);
    this.handleRetrieveRecords();
  }

  handleManageTags = (e) => {
    const { aggregateView, editDatabasePath } = this.props;
    if (!aggregateView) {
      clickAsLink(window, `${editDatabasePath}?tab=tagsTab`, e);
    }
  }

  render() {
    const { availableTags } = this.props;

    return (
      <React.Fragment>
        {availableTags.length > 0 && this.renderTagsButton()}
      </React.Fragment>
    );
  }

  renderTagsButton() {
    const { selectedTags } = this.props;
    return (
      <FilterButton
        filtersApplied={selectedTags.length > 0}
        label="Tags"
        name="tags-filter"
      >
        {this.renderTagsFilter()}
      </FilterButton>
    );
  }

  renderTagsFilter() {
    const {
      aggregateView,
      availableTags,
      selectedTags,
      excludeTags
    } = this.props;

    return (
      <TagsFilter
        availableTags={availableTags}
        canManageTags={!aggregateView}
        excludeTags={excludeTags}
        selectedTags={selectedTags}
        onAdd={this.handleAddTag}
        onRemove={this.handleRemoveTag}
        onSelectAllChange={this.handleSelectAllChange}
        onSelectExcludeTags={this.handleExcludeTagsChange}
        onSelectManageTags={this.handleManageTags}
      />
    );
  }
}

const mapStateToProps = state => ({
  availableTags: state.static.tags,
  aggregateView: state.static.aggregateView,
  editDatabasePath: state.paths.database.edit,
  excludeTags: state.query.excludeTags,
  selectedTags: state.query.tags,
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  selectExcludeTags,
  setTags,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchTagsFilter);
